module.exports = __webpack_public_path__ + "static/media/top-clouds-1@2x.aec3ad93.png";